import React from "react";
import useDebugInformation from "../../../../../../../../../../hooks/useDebugInformation";
import { useAppSelector } from "@store/hooks";
import { handleGroupChange } from "@utils/general";
import ComboDropDown from "../../../../../../../../../Shared/ComboDropDown";
import { categoryGetOptionLabel, categoryIsOptionEqualToValue } from "./helpers";

const name = "CategoryDropDown"

type Props = {
    parent: string
}

const CategoryDropDown: React.FC<Props> = ({ parent }) => {
    const problemComboCategory = useAppSelector(({ ui }) => ui.ProblemComboCategory)
    const problemCategories = useAppSelector(({ ui }) => ui.ProblemCategories)

    const debugName = `${parent}▷[${name}]`

    useDebugInformation(debugName, { parent, problemComboCategory, problemCategories })
    return (

        <ComboDropDown
            sm={6}
            name="Category"
            options={React.useMemo(() => problemCategories && problemCategories.length > 0 ? problemCategories : [], [problemCategories])}
            getOptionLabel={categoryGetOptionLabel}
            isOptionEqualToValue={categoryIsOptionEqualToValue}
            onChange={handleGroupChange}
            value={problemComboCategory}
        />
    )
}

export default React.memo(CategoryDropDown)